import Pikaday from 'pikaday';

moment.locale($('html').attr('lang'));

export default function formsRangePickerUI() {
	initMeetingDatepicker();
};

const format = 'D/MM/YYYY';
let numberOfMonths;
let isKeyboard = false;
let bound = true;

const initMeetingDatepicker = () => {
	const $datepickers = $('.js-datepicker-forms');
	numberOfMonths = 1;

	$datepickers.each((index, el) => {
		const $datepicker = $(el);

		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		const containerStart = el.querySelector('.js-datepicker-container-start');
		const containerEnd = el.querySelector('.js-datepicker-container-end');

		let startDate, endDate;

		const options = {
			minDate: new Date(),
			numberOfMonths,
			bound: true,
			format,
			firstDay: 0,
			i18n: {
				months        : moment.months(),
				weekdays      : moment.weekdays(),
				weekdaysShort : moment.weekdaysShort()
			}
		}

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endPicker.setMinDate(startDate);
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			container: containerStart,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();

					setTimeout(function() {
						const nextDate = moment(startDate).add(1, 'days');
						const selectedMonth = nextDate.month();
						const selectedYear = nextDate.year();

						$(fieldEnd).val(nextDate.format(format));
						startPicker.setEndRange(startDate._d);
						endPicker.setEndRange(startDate._d);

						endPicker.gotoMonth(selectedMonth);
						endPicker.gotoYear(selectedYear);

						$(fieldEnd).focus();
					}, 10);
				}
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			container: containerEnd,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}

        //Fix tabbing order
        $(fieldStart).add($(fieldEnd)).on('focusin', function(event) {
            setTimeout(function() {
        	   $('.pika-single button, .pika-single a').attr('tabindex', -1);
                // body...
            }, 10)
        });

		$(fieldEnd).on('focusin', function() {
			if ( !endDate && isKeyboard ) {
				endDate = moment(startDate, format).add(1, 'days')._d;

				endPicker.setDate(endDate);

				updateEndDate();
			}
		});

		$(fieldStart).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = startPicker.getDate() ? startPicker.getDate() : new Date();

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				startDate = updateDateByKeyboard(currentDate, code);

				if ( startPicker._o.maxDate && startDate.getTime() > startPicker._o.maxDate.getTime() ) {
					startDate = startPicker._o.maxDate;
				}

				if ( endDate ) {
					// Prevent startDate from going over endDate
					if ( startDate.getTime() == endDate.getTime() ) {
						startDate = moment(startDate, format).subtract(1, 'days')._d;

						setTimeout(function() {
							$(fieldStart).val(startDate);
						}, 10);
					}
				}

				// Prevent startDate from going to a date before the minDate
				if ( startDate.getTime() < startPicker._o.minDate ) {
					startDate = startPicker._o.minDate;
				}

				// Check if the endDate is the day after startDate
				const isEndDateNext = endDate ? endDate.getTime() == moment(startDate, format).add(1, 'days')._d.getTime() : false;

				if (isEndDateNext) {
					// If it is, re-set the startDate to the day before that
					startDate == moment(endDate, format).subtract(1, 'days')._d;

					setTimeout(function() {
						startPicker.setDate(startDate);
					}, 10);
				}

				updateStartDate();
			}
		});

		$(fieldEnd).on('keydown', function(event) {
			const code = event.keyCode;
			const currentDate = endPicker.getDate() ? endPicker.getDate() : endPicker._o.minDate;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				endDate = updateDateByKeyboard(currentDate, code);

				if ( endPicker._o.minDate && endDate.getTime() < endPicker._o.minDate.getTime() ) {
					endDate = endPicker._o.minDate;
				}

				if ( startDate ) {
					// Prevent startDate from going over endDate
					if ( startDate.getTime() == endDate.getTime() ) {
						endDate = moment(endDate, format).add(1, 'days')._d;

						setTimeout(function() {
							$(fieldEnd).val(endDate);
						}, 10);
					}
				}

				// Check if the startDate is the day before endtDate
				const isStartDatePrev = startDate ? startDate.getTime() == moment(endDate, format).subtract(1, 'days')._d.getTime() : false;

				if (isStartDatePrev) {
					// If it is, re-set the startDate to the day before that
					endDate == moment(startDate, format).add(1, 'days')._d;

					setTimeout(function() {
						endPicker.setDate(endDate);
					}, 10);
				}

				updateEndDate();
			}
		});

		function updateDateByKeyboard(originalDate, code) {
			let date;

			if ( code == 37 || code == 38 || code == 39 || code == 40 ) {
				isKeyboard = true;
			}

			switch(code){
				case 37:
					date = moment(originalDate, format).subtract(1, 'days')._d;
					break;
				case 38:
					date = moment(originalDate, format).subtract(7, 'days')._d;
					break;
				case 39:
					date = moment(originalDate, format).add(1, 'days')._d;
					break;
				case 40:
					date = moment(originalDate, format).add(7, 'days')._d;
					break;
			}

			setTimeout(function() {
				isKeyboard = false;
			}, 20);

			return date;
		}
	});
}
